"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mobilePhoneFactory = void 0;
const Factory = require("factory.ts");
exports.mobilePhoneFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    phone: '5551234567',
    password_token: null,
    validated: false,
    reset_expiration: null,
    user_id: null,
});
